import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ReferralsRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard component that only renders children if ?referrals=on is in the URL query parameters.
 * If the parameter is not present, redirects to the home page.
 */
const ReferralsRoute: React.FC<ReferralsRouteProps> = ({ children }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isReferralsEnabled = searchParams.get('referrals') === 'on';

  if (!isReferralsEnabled) {
    // Redirect to home page if referrals is not enabled
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ReferralsRoute;

